(function () {
  if (window.__productTransparencyInit) return;
  window.__productTransparencyInit = true;

  function isBlank(value) {
    if (value === null || value === undefined) return true;
    if (typeof value === 'string') return value.trim() === '';
    if (Array.isArray(value)) return value.length === 0;
    return false;
  }

  function normalizeValue(value) {
    if (isBlank(value)) return '';
    var text = String(value).trim();
    if (!text) return '';
    if (text.toLowerCase() === 'n/a') return '';
    if (text.toLowerCase() === 'null') return '';
    if (text.toLowerCase() === 'undefined') return '';
    return text;
  }

  function parseMaybeJson(value) {
    if (isBlank(value)) return null;
    if (typeof value === 'object') return value;
    if (typeof value !== 'string') return value;

    var parsed = value;
    for (var i = 0; i < 3; i += 1) {
      if (typeof parsed !== 'string') return parsed;

      var trimmed = parsed.trim();
      if (!trimmed) return null;

      var first = trimmed.charAt(0);
      var last = trimmed.charAt(trimmed.length - 1);
      var looksLikeJson = first === '{' || first === '[';
      var looksLikeQuotedJson = first === '"' && last === '"';

      if (!looksLikeJson && !looksLikeQuotedJson) return trimmed;

      try {
        parsed = JSON.parse(trimmed);
      } catch (error) {
        return trimmed;
      }
    }

    return parsed;
  }

  function readSectionJson(section, selector) {
    var node = section.querySelector(selector);
    if (!node) return null;
    return parseMaybeJson(node.textContent);
  }

  function decodeHtmlEntities(value) {
    if (isBlank(value)) return '';
    var textarea = document.createElement('textarea');
    textarea.innerHTML = String(value);
    return textarea.value;
  }

  function stripHtml(html) {
    if (isBlank(html)) return '';
    var container = document.createElement('div');
    container.innerHTML = decodeHtmlEntities(String(html));
    return (container.textContent || container.innerText || '').trim();
  }

  function truncateWords(text, maxWords) {
    var normalized = normalizeValue(text);
    if (!normalized) return '';

    var words = normalized.split(/\s+/).filter(Boolean);
    if (words.length <= maxWords) return normalized;
    return words.slice(0, maxWords).join(' ') + '...';
  }

  function formatCurrency(value) {
    var normalized = normalizeValue(value);
    if (!normalized) return 'N/A';
    if (normalized.indexOf('$') > -1) return normalized;
    return '$' + normalized;
  }

  function formatLotSize(value) {
    var normalized = normalizeValue(value);
    if (!normalized) return 'N/A';
    if (normalized === '0' || normalized === '-1') return '∞';
    if (normalized.toUpperCase().indexOf('LB') > -1) return normalized;
    return normalized + ' LBS';
  }

  function pickField(candidates, fieldName) {
    for (var i = 0; i < candidates.length; i += 1) {
      var candidate = candidates[i];
      if (!candidate || typeof candidate !== 'object' || Array.isArray(candidate)) continue;
      if (!isBlank(candidate[fieldName])) return candidate[fieldName];
    }
    return null;
  }

  function resolveCandidates(section) {
    var metafieldRaw = readSectionJson(section, '[data-trans-kirby-metafield]');
    var contentRaw = readSectionJson(section, '[data-trans-kirby-content]');
    var valueRaw = readSectionJson(section, '[data-trans-kirby-content-value]');
    var shopRaw = readSectionJson(section, '[data-trans-shop-blurbs]');
    var shopValueRaw = readSectionJson(section, '[data-trans-shop-blurbs-value]');
    var shopContentRaw = readSectionJson(section, '[data-trans-shop-blurbs-content]');

    var metafield = parseMaybeJson(metafieldRaw);
    var content = parseMaybeJson(contentRaw);
    var value = parseMaybeJson(valueRaw);
    var shopMeta = parseMaybeJson(shopRaw);
    var shopValue = parseMaybeJson(shopValueRaw);
    var shopContent = parseMaybeJson(shopContentRaw);

    var metafieldValue = null;
    if (metafield && typeof metafield === 'object' && !Array.isArray(metafield) && metafield.value !== undefined) {
      metafieldValue = parseMaybeJson(metafield.value);
    }

    var nested = null;
    var nestedCandidates = [metafield, metafieldValue, value, content];
    for (var i = 0; i < nestedCandidates.length; i += 1) {
      var candidate = nestedCandidates[i];
      if (!candidate || typeof candidate !== 'object' || Array.isArray(candidate)) continue;
      if (candidate.content === undefined) continue;
      nested = parseMaybeJson(candidate.content);
      if (nested) break;
    }

    if (!shopValue && shopMeta && typeof shopMeta === 'object' && !Array.isArray(shopMeta) && shopMeta.value !== undefined) {
      shopValue = parseMaybeJson(shopMeta.value);
    }

    var shopContentResolved = shopContent;
    var shopCandidatesForContent = [shopMeta, shopValue];
    for (var j = 0; j < shopCandidatesForContent.length; j += 1) {
      var shopCandidate = shopCandidatesForContent[j];
      if (!shopCandidate || typeof shopCandidate !== 'object' || Array.isArray(shopCandidate)) continue;
      if (shopCandidate.content === undefined) continue;
      shopContentResolved = parseMaybeJson(shopCandidate.content);
      if (shopContentResolved) break;
    }

    return {
      product: [nested, metafieldValue, value, metafield, content],
      shop: [shopContentResolved, shopContent, shopValue, shopMeta]
    };
  }

  function resolveBlurb(productCandidates, shopCandidates, productKey, shopKeys) {
    var blurb = pickField(productCandidates, productKey);
    if (!isBlank(blurb)) return blurb;

    for (var i = 0; i < shopKeys.length; i += 1) {
      blurb = pickField(shopCandidates, shopKeys[i]);
      if (!isBlank(blurb)) return blurb;
    }

    return '';
  }

  function openModal(modal) {
    if (!modal) return;
    modal.classList.add('active');
    document.documentElement.classList.add('stuck');
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('active');

    var hasOpenModal = document.querySelector('.coffee-modal.active');
    if (!hasOpenModal) {
      document.documentElement.classList.remove('stuck');
    }
  }

  function setupTabs(section) {
    var tabs = Array.prototype.slice.call(section.querySelectorAll('.fin-trans .trans-tab'));
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var activeTab = section.querySelector('.fin-trans .trans-tab.active');
        if (activeTab === tab) return;

        if (activeTab) {
          var activeVideo = activeTab.querySelector('.trans-img video');
          if (activeVideo) activeVideo.pause();
          activeTab.classList.remove('active');
        }

        tab.classList.add('active');

        var newVideo = tab.querySelector('.trans-img video');
        if (newVideo && typeof newVideo.play === 'function') {
          var playPromise = newVideo.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        }
      });
    });
  }

  function getModalOwnerId(section) {
    if (!section) return '';
    var sectionId = section.getAttribute('id') || '';
    if (sectionId.indexOf('product-transparency-') === 0) {
      return sectionId.replace('product-transparency-', '');
    }
    return '';
  }

  function removePortaledModals(ownerId) {
    if (!ownerId || !document.body) return;

    var selector = '.coffee-modal[data-product-transparency-modal][data-modal-owner="' + ownerId + '"]';
    var modals = Array.prototype.slice.call(document.body.querySelectorAll(selector));
    modals.forEach(function (modal) {
      if (modal.classList.contains('active')) {
        closeModal(modal);
      }
      modal.remove();
    });
  }

  function portalModals(section) {
    if (!document.body) return;

    var ownerId = getModalOwnerId(section);
    removePortaledModals(ownerId);

    var modals = Array.prototype.slice.call(section.querySelectorAll('.coffee-modal'));
    if (!modals.length) return;

    var sectionStyle = section.getAttribute('style') || '';

    modals.forEach(function (modal) {
      modal.setAttribute('data-product-transparency-modal', '');
      if (ownerId) {
        modal.setAttribute('data-modal-owner', ownerId);
      }
      if (sectionStyle) {
        modal.setAttribute('style', sectionStyle);
      }

      if (modal.parentNode !== document.body) {
        document.body.appendChild(modal);
      }

      if (modal.dataset.portalBound === 'true') return;
      modal.dataset.portalBound = 'true';

      var closeButtons = modal.querySelectorAll('.modal-close');
      closeButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          closeModal(modal);
        });
      });
    });
  }

  function setupModals(section) {
    section.addEventListener('click', function (event) {
      var learnMoreButton = event.target.closest('.trans-learn-more');
      if (learnMoreButton) {
        event.preventDefault();
        var modalId = learnMoreButton.getAttribute('data-id');
        if (!modalId) return;

        var openModalNode = document.querySelector('.coffee-modal[data-product-transparency-modal].active');
        if (openModalNode) closeModal(openModalNode);

        var modalNode = document.getElementById(modalId);
        openModal(modalNode);
      }
    });
  }

  function applyKirbyData(section) {
    var candidates = resolveCandidates(section);
    var previewWords = Number(section.getAttribute('data-preview-words')) || 30;

    var metrics = [
      {
        valueKey: 'trans_green',
        previewKey: 'green',
        modalKey: 'green',
        productBlurbKey: 'trans_green_blurb',
        shopBlurbKeys: ['green_cost_blurb'],
        formatter: formatCurrency
      },
      {
        valueKey: 'trans_grade',
        previewKey: 'grade',
        modalKey: 'grade',
        productBlurbKey: 'trans_grade_blurb',
        shopBlurbKeys: ['transparency_grade_blurb'],
        formatter: function (value) {
          return normalizeValue(value) || 'N/A';
        }
      },
      {
        valueKey: 'trans_c_market',
        previewKey: 'market',
        modalKey: 'market',
        productBlurbKey: 'trans_c_market_blurb',
        shopBlurbKeys: ['c_market_blurb', 'fair_trade_blurb'],
        formatter: formatCurrency
      },
      {
        valueKey: 'trans_transportation',
        previewKey: 'transportation',
        modalKey: 'transportation',
        productBlurbKey: 'trans_transportation_blurb',
        shopBlurbKeys: ['transportation_blurb'],
        formatter: formatCurrency
      },
      {
        valueKey: 'cup_score',
        previewKey: 'cup_score',
        modalKey: 'cup_score',
        productBlurbKey: 'trans_cup_score_blurb',
        shopBlurbKeys: ['cup_score_blurb'],
        formatter: function (value) {
          return normalizeValue(value) || 'N/A';
        }
      },
      {
        valueKey: 'batch_size_lbs',
        previewKey: 'lot_size',
        modalKey: 'lot_size',
        productBlurbKey: 'trans_lot_size_blurb',
        shopBlurbKeys: ['lot_size_blurb'],
        formatter: formatLotSize
      }
    ];

    metrics.forEach(function (metric) {
      var rawValue = pickField(candidates.product, metric.valueKey);
      var formattedValue = metric.formatter(rawValue);

      var valueEl = section.querySelector('[data-trans-value-key="' + metric.valueKey + '"]');
      if (valueEl) valueEl.textContent = formattedValue;

      var blurbHtml = resolveBlurb(candidates.product, candidates.shop, metric.productBlurbKey, metric.shopBlurbKeys);
      var decodedBlurb = decodeHtmlEntities(blurbHtml);
      var previewText = truncateWords(stripHtml(decodedBlurb), previewWords);

      var previewEl = section.querySelector('[data-trans-preview-key="' + metric.previewKey + '"]');
      if (previewEl) previewEl.textContent = previewText;

      var modalEl = section.querySelector('[data-trans-modal-key="' + metric.modalKey + '"]');
      if (modalEl && !isBlank(decodedBlurb)) {
        modalEl.innerHTML = decodedBlurb;
      }

      var learnMoreBtn = section.querySelector('.trans-learn-more[data-id*="' + metric.modalKey.replace('_', '-') + '"]');
      if (learnMoreBtn && isBlank(decodedBlurb)) {
        learnMoreBtn.hidden = true;
      }
    });
  }

  function initSection(section) {
    if (!section || section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    applyKirbyData(section);
    portalModals(section);
    setupTabs(section);
    setupModals(section);
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-product-transparency]');
    sections.forEach(function (section) {
      initSection(section);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var activeModal = document.querySelector('.coffee-modal[data-product-transparency-modal].active');
    if (activeModal) closeModal(activeModal);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var section = null;
    if (event && event.target) {
      if (event.target.matches && event.target.matches('[data-product-transparency]')) {
        section = event.target;
      } else {
        section = event.target.querySelector('[data-product-transparency]');
      }
    }
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var ownerId = '';

    if (event && event.target) {
      var section = null;
      if (event.target.matches && event.target.matches('[data-product-transparency]')) {
        section = event.target;
      } else if (event.target.querySelector) {
        section = event.target.querySelector('[data-product-transparency]');
      }

      if (section) {
        ownerId = getModalOwnerId(section);
      }

      if (!ownerId && event.target.id && event.target.id.indexOf('shopify-section-') === 0) {
        ownerId = event.target.id.replace('shopify-section-', '');
      }
    }

    if (ownerId) {
      removePortaledModals(ownerId);
    }
  });
})();
